import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import APIUrls from '../../core/ApiUrls';
import { MakeAxiosRequest } from '../../core/utils';

const SuperLogin = () => {
    const [available, setAvailable] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');
    const navigate = useNavigate();

    const login = async () => {
        if (!email.trim()) {
            toast.error('Fill in the email');
            return;
        }
        try {
            const res = await MakeAxiosRequest('POST', APIUrls.getURL('SUPERLOGIN'), { email });
            if (res?.status === 200) {
                navigate('/dashboard');
            }
        } catch (error) {
            console.log('error');
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const res = await MakeAxiosRequest('GET', APIUrls.getURL('SUPERLOGIN'));
            setAvailable(res?.data?.data?.available);
        };
        fetchData();
    }, []);
    return (
        <div>
            {available ? (
                <div>
                    <input type="text" value={email} onChange={e => setEmail(e.target.value)} placeholder="email" />
                    <button onClick={login}>submit</button>
                </div>
            ) : (
                <div>PAGE_NOT_FOUND</div>
            )}
        </div>
    );
};

export default SuperLogin;
